import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, Space, Popover } from 'antd';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import { toISTDate } from '../../../../../apis/constants';

const ListScreenKeys = ({ documentData, MONEY, priceMasking }) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];
  const record = documentData;

  const createdDate = (
    <div>
      <div>
        {toISTDate(record?.created_at).format('DD/MM/YYYY hh:mm A')}
      </div>
      <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
    </div>
  );
  const paymentStatus = (
    <div
      style={{
        color: Helpers.getStatusColor(record?.grn_billing_details?.grn_billing_status).color,
      }}
      className="min-width-115"
    >
      {Helpers.getStatusColor(record?.grn_billing_details?.grn_billing_status).text?.toUpperCase()}
    </div>
  );
  const ewbNumber = (
    <div >
      {
        record?.e_way_bill?.length > 0 ? record?.e_way_bill?.map((item) => (
          <div>
            <a href={item?.url} target="_blank" rel="noreferrer">{record?.e_way_bill_number}</a>
          </div>
        )) : <div>{record?.e_way_bill_number}</div>
      }
    </div>
  );
  const labels = (
    <Space size={[0, 8]} wrap>
      {record?.tags?.map((tag, index) => (
        <Tag
          key={index}
          color={colorArray[index]}
        >
          {tag}
        </Tag>
      ))}
    </Space>
  );
  const reference = (
    <div className="associated-entity min-width-85">
      {record?.grn_entity_type === 'PURCHASE_ORDER' ? (
        record?.po_number ? (
          <Link to={`/approval?type=po&id=${record.grn_entity_id}`} target="_blank">
            {record.po_number}
          </Link>
        ) : (
          <span>-</span>
        )
      ) : (
        record?.stock_transfers?.[0]?.stock_transfer_number ? (
          <Link to={`/inventory/stock-transfer/view/${record.grn_entity_id}`} target="_blank">
            {record.stock_transfers[0].stock_transfer_number}
          </Link>
        ) : (
          <span>-</span>
        )
      )}
    </div>
  );
  const gateDocNumber = record?.ref_gate_document;

  const otherDocs = (
    <div>
      {
        gateDocNumber?.slice(2).map((document, i) => (
          <div className="other-uom-stock" key={i}>
            <div
              onClick={() => window.open(`/logistic/gate-document/view/${document?.gate_document_id}`)}
              style={{
                cursor: 'pointer',
              }}
            >
              {document?.gate_document_number}
            </div>
          </div>
        ))
      }
    </div>
  );
  const gateDocNumberHtml = (
    <Popover
      placement="bottom"
      content={gateDocNumber?.length > 2 && otherDocs}
      trigger="hover"
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      <div className="min-width-115">
        {gateDocNumber?.slice(0, 2)?.map((document) => (
          <Link
            to={`/logistic/gate-document/view/${document?.gate_document_id}`}
            target="_blank"
            key={document?.gate_document_id}
          >
            <div className="associated-entity">
              {document?.gate_document_number}
            </div>
          </Link>
        ))}
        {document?.length > 2 && (
          <H3Text
            className="table-subscript-grey"
            text={`and ${document.length - 2} more`}
          />
        )}
      </div>
    </Popover>
  );
  const attachments = (
    <div >
      {
        record?.attachments?.map((item, index) => (
          <div>
            <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
          </div>
        ))
      }
    </div>
  );

  return [
    {
      label: 'Vendor Invoice #',
      value: record?.invoice_number || '-',
    },
    {
      label: 'Reference #',
      value: reference || '-',
    },
    {
      label: 'Gate Document Number',
      value: gateDocNumberHtml || '-',
    },
    {
      label: 'Items',
      value: record?.po_lines_count || '-',
    },
    {
      label: 'Amount (Without Tax)',
      value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to grand total" /> : MONEY((record?.grn_base_price || '0'), record?.org_currency_info?.currency_code),
    },
    {
      label: 'Taxes',
      value: MONEY((record?.grn_gst || '0'), record?.org_currency_info?.currency_code),
    },
    {
      label: 'Created Date',
      value: createdDate,
    },
    {
      label: 'EWB Number',
      value: ewbNumber,
    },
    {
      label: 'Payment Status',
      value: paymentStatus,
    },
    {
      label: 'Labels',
      value: labels || '-',
    },
    {
      label: 'Attachments',
      value: attachments || '-',
    },
  ];
};

export {
  ListScreenKeys,
};
